import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog6() {
  pageTitle('2024 Government Incentives: Your Complete Guide to Renewable Energy Savings');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="2024 Government Incentives: Your Complete Guide to Renewable Energy Savings"
        variant="text-center"
        shape="shape_5"
        category="Financial Incentives"
        date="26 Nov 2024"
        avatar="Policy Updates"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Government Incentives"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Maximize Your Savings with Current Government Incentives
          </h3>
          <p>
            2024 brings unprecedented opportunities for renewable energy adoption with enhanced federal and state incentives. Learn how to leverage these programs to reduce your installation costs by up to 60%.
          </p>
          <p>
            From tax credits to rebates and grants, we'll guide you through every available incentive to maximize your savings on renewable energy investments.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Tax Credits"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Rebate Programs"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Grant Opportunities"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Available Incentives Breakdown</h3>
          <p>
            Understanding and applying for government incentives can be complex. Our team at Soketry Solutions handles the entire process, ensuring you receive every eligible benefit.
          </p>
          <blockquote>
            "Thanks to Soketry's guidance, we secured over $25,000 in government incentives for our solar installation. The process was seamless, and the savings were substantial."
            <small>Robert Wilson, Recent Solar Adopter</small>
          </blockquote>
          <p>
            Let us help you navigate the incentive landscape and maximize your renewable energy investment returns.
          </p>
          <ul>
            <li>Federal Tax Credit: Up to 30% of system cost</li>
            <li>State Rebates: Additional 10-20% savings</li>
            <li>Local Utility Incentives: Varies by location</li>
            <li>Special Business Depreciation Benefits</li>
            <li>Performance-Based Incentives</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Government Incentives
            </a>
            <a href="/" className="cs_category">
              Tax Credits
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on government incentives"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 